<script>
export default {
  props: {
    title: String,
    image: String
  }
};
</script>

<template>
  <div @click="$emit('clicked')">
    <img :src="`/static/${image}`" height="25px" :alt="title">
    <p>{{title}}</p>
  </div>
</template>

<style scoped>
div {
  display: flex;
  height: 30px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--purple);
  border-radius: 2px;
  color: var(--purple);
  font-size: 12px;
  text-transform: uppercase;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.24s ease;
  padding: 10px;
}

div:hover {
  background-color: var(--purple-off-white);
}

img {
  margin-right: 10px;
}

p {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/_Button.vue